export interface UserDocument {
  id: string;
  profilePicture: string;
  websiteUrl?: string;
  WebsiteUrl?: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  displayName?: string;
  headline: string;
  headerBio: string;
  about: string;
  city: string;
  country: string;
  username: string;
  sharedProfileUrl: string;
  youTubeProfileUrl: string;
  instagramProfileUrl: string;
  facebookProfileUrl: string;
  linkedInProfileUrl: string;
  xProfileUrl: string;
  tikTokProfileUrl: string;
  currency: string;
  rate: number;
  feedbackRating: number;
  attendance: number;
  bookings: number;
  followers: number;
  following: number;
  isProfessional: boolean;
  enabled: boolean;
  categories: string[];
  searchTerms: string[];
  languages: string[];
}

export const getProfilePicture = (encodedData?: string) => {
  if (!encodedData) {
    return undefined;
  }

  if (encodedData.startsWith('http://') || encodedData.startsWith('https://')) {
    return encodedData;
  }

  const basePrefix = 'data:image/';
  const webpPrefix = `${basePrefix}webp;base64,`;
  const pngPrefix = `${basePrefix}png;base64,`;
  const jpgPrefix = `${basePrefix}jpg;base64,`;
  const jpgPrefix2 = `${basePrefix}jpeg;base64,`;

  const data = encodedData
    .replace(webpPrefix, '')
    .replace(pngPrefix, '')
    .replace(jpgPrefix, '')
    .replace(jpgPrefix2, '');
  return `${webpPrefix}${data}`;
};

export interface ExtendedFacetResult {
  value: any;
  count: number;
}

export interface UserDocumentModel {
  facets: { [key: string]: ExtendedFacetResult[] };
  users: UserDocument[];
}

export interface SearchExpressionInputModel {
  searchText: string;
  filterExpression: string;
  skip: number;
  size: number;
}
